var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAudioExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A4A9C8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 19.5H39c-2.485 0-4.5 2.015-4.5 4.5v6c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5V12c0-2.485-2.015-4.5-4.5-4.5s-4.5 2.015-4.5 4.5v24c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5V18c0-2.485-2.015-4.5-4.5-4.5s-4.5 2.015-4.5 4.5v6c0 .828-.672 1.5-1.5 1.5H7.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5H9c2.485 0 4.5-2.015 4.5-4.5v-6c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v18c0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5V12c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v18c0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5v-6c0-.828.672-1.5 1.5-1.5h1.5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5z",
    transform: "translate(-1000 -301) translate(1000 301)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAudioExperiment);
export default __webpack_public_path__ + "static/media/ico-audio-experiment.aacd36becd00bc4de4cb042b1d2e12ae.svg";
export { ForwardRef as ReactComponent };